import { render, staticRenderFns } from "./RentUnitDetails.vue?vue&type=template&id=5fbb34a8&scoped=true&"
import script from "./RentUnitDetails.vue?vue&type=script&lang=js&"
export * from "./RentUnitDetails.vue?vue&type=script&lang=js&"
import style0 from "./RentUnitDetails.vue?vue&type=style&index=0&id=5fbb34a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbb34a8",
  null
  
)

export default component.exports